import * as api from '@/api/give-course/portrayal'
import * as TYPES from './type';

export default {
  //授课 教学轨迹
  async getSKteachingTrack({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKteachingTrack(paramets)
    commit(TYPES.SK_PORTRAYAL_TEACHING_TRACK, { result })
    cb && cb()
  },
  //授课 到课率
  async getSKcourseRatio({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKcourseRatio(paramets)
    commit(TYPES.SK_PORTRAYAL_COURSE_RATIO, { result })
    cb && cb()
  },
  //授课 作业率
  async getSKhomeworkRatio({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKhomeworkRatio(paramets)
    commit(TYPES.SK_PORTRAYAL_HOMEWORK_RATIO, { result })
    cb && cb()
  },
  //授课 任务率
  async getSKtaskRatio({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKtaskRatio(paramets)
    commit(TYPES.SK_PORTRAYAL_TASK_RATIO, { result })
    cb && cb()
  },
  //授课 测试率
  async getSKtestRatio({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKtestRatio(paramets)
    commit(TYPES.SK_PORTRAYAL_TEST_RATIO, { result })
    cb && cb()
  },
  //授课 小组排名
  async getSKgroupList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKgroupList(paramets)
    commit(TYPES.SK_PORTRAYAL_GROUP_LIST, { result })
    cb && cb()
  },
  //授课 学生进步排名
  async getSKstuImproveList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKstuImproveList(paramets)
    commit(TYPES.SK_PORTRAYAL_STU_IMPROVE_LIST, { result })
    cb && cb()
  },
  //授课 学生活跃排名
  async getSKstuLivelyList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKstuLivelyList(paramets)
    commit(TYPES.SK_PORTRAYAL_STU_LIVELY_LIST, { result })
    cb && cb()
  },
  //授课 学生素质排名
  async getSKstuQualityList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKstuQualityList(paramets)
    commit(TYPES.SK_PORTRAYAL_STU_QUALITY_LIST, { result })
    cb && cb()
  },
  //授课 学生成绩排名
  async getSKstuAchievementList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKstuAchievementList(paramets)
    commit(TYPES.SK_PORTRAYAL_STU_ACHIEVEMENT_LIST, { result })
    cb && cb()
  },
  //授课 活动参与率
  async getSKactiveRatio({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKactiveRatio(paramets)
    commit(TYPES.SK_PORTRAYAL_ACTIVE_RATIO, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/portrayal/actions.js